import { render, staticRenderFns } from "./TravelerTypesForm.vue?vue&type=template&id=2885fc17&"
import script from "./TravelerTypesForm.vue?vue&type=script&lang=js&"
export * from "./TravelerTypesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports